import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import type { PriceEstimatorTableI18nKeys } from './types';
import { Spinner } from '../Spinner';

export function PriceEstimatorTable({
  isLoading,
  i18nKeys: i18n,
  planType,
  children,
}: {
  isLoading: boolean;
  i18nKeys: PriceEstimatorTableI18nKeys;
  planType: string;
  children?: ReactNode;
}) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="price-estimator-table-loading">
        <Spinner size="lg" />
      </div>
    );
  }

  return (
    <div className="price-estimator-table">
      <table className="price-selector-table" data-qe-id="price-selector-table">
        <thead>
          <tr>
            <th scope="col" className="price-estimator-contact-col price-table-head">
              {t(i18n.listSize)}
            </th>
            <th scope="col" className="price-estimator-pricing-col price-table-head">
              {t(i18n.plans[planType] ?? i18n.unknownPlanType)}
            </th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
}
